/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Checkbox } from '@pulsarml/ui.react.components';
import React from 'react';
import cn from 'classnames';
import { MachineGroup, MachineGroupSelectorType } from 'types';
import { I18n } from '@utils/i18n';
import styles from './index.module.scss';

interface MachineGroupsContainerProps {
  machineGroups: MachineGroupSelectorType;
  selectedMachineGroups: MachineGroup[] | undefined;
  allowAllMachines: boolean;
  selectedMachineGroupId?: string;
  onAllMachinesGroupSelection: () => void;
  onGroupSelection: (machineGroup: MachineGroup) => void;
  'data-testid'?: string;
}
function MachineGroupsContainer(props: MachineGroupsContainerProps) {
  return (
    <div
      className={styles['machine-groups-container']}
      data-testid={props['data-testid']}
    >
      {props.allowAllMachines && (
        <div
          className={cn(
            styles.machineGroupCheckboxContainer,
            props.selectedMachineGroupId === 'all-machines' && styles.active
          )}
        >
          <Checkbox
            classNames={`flex-1 ${styles.machineGroupCheckbox}`}
            label={I18n.t('all_machines')}
            checked={
              props.selectedMachineGroups
                ?.map((e) => e.id)
                .includes('all-machines') ?? false
            }
            onChange={props.onAllMachinesGroupSelection}
          />
        </div>
      )}
      {props.machineGroups.list
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((machineGroup) => (
          <div
            className={cn(
              styles.machineGroupCheckboxContainer,
              props.selectedMachineGroupId === machineGroup.id && styles.active
            )}
            key={machineGroup.id}
          >
            <Checkbox
              classNames={`flex-1 ${styles.machineGroupCheckbox}`}
              label={machineGroup.name}
              checked={
                props.selectedMachineGroups
                  ?.map((e) => e.id)
                  .includes(machineGroup.id) ?? false
              }
              onChange={() => {
                props.onGroupSelection(machineGroup);
              }}
            />
          </div>
        ))}
    </div>
  );
}

export default MachineGroupsContainer;
